export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9019.4c41a20d.jpg";